import {
  ColumnLayout,
  Box,
  Button,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { COMMON_LABELS } from "../default-constants";
import {
  NEW_OR_PULLBACK,
  SEND_BACK,
  REQUEST_AFTER_FOR_REQUESTER,
  EXAMINATION_COMPREHENSIVE_WAITING_MANUAL,
  REQUEST_AFTER_FOR_APPROVER_ADMIN,
} from "./constants";
import {
  CancelableEventHandler,
  ClickDetail,
} from "@cloudscape-design/components-themed/internal/events";

interface IFooter {
  currentStage: number;
  examinationStatus: number;
  backOnClick: CancelableEventHandler<ClickDetail>;
  approvalRequestOnClick: CancelableEventHandler<ClickDetail>;
  pullbackOnClick: CancelableEventHandler<ClickDetail>;
  sendBackOnClick: CancelableEventHandler<ClickDetail>;
  approvalOnClick: CancelableEventHandler<ClickDetail>;
  examinationPossibleFlag: boolean;
}

/**
 * フッターのボタン群
 */
const Footer = (props: IFooter) => {
  const {
    currentStage,
    examinationStatus,
    backOnClick,
    approvalRequestOnClick,
    pullbackOnClick,
    sendBackOnClick,
    approvalOnClick,
    examinationPossibleFlag,
  } = props;
  const displayApprovalRequestButton =
    [NEW_OR_PULLBACK, SEND_BACK].includes(currentStage) &&
    examinationPossibleFlag;
  const displayPullBackButton =
    currentStage === REQUEST_AFTER_FOR_REQUESTER &&
    examinationStatus === EXAMINATION_COMPREHENSIVE_WAITING_MANUAL &&
    examinationPossibleFlag;
  const displayApprovalButton =
    currentStage === REQUEST_AFTER_FOR_APPROVER_ADMIN &&
    examinationStatus === EXAMINATION_COMPREHENSIVE_WAITING_MANUAL &&
    examinationPossibleFlag;

  return (
    <ColumnLayout columns={2}>
      <Box float={"left"}>
        <Button formAction={"none"} variant={"link"} onClick={backOnClick}>
          {COMMON_LABELS.BTNS.BACK}
        </Button>
      </Box>
      {displayApprovalRequestButton && (
        <Box float={"right"}>
          <Button variant={"primary"} onClick={approvalRequestOnClick}>
            {COMMON_LABELS.BTNS.APPROVAL_REQUEST}
          </Button>
        </Box>
      )}
      {displayPullBackButton && (
        <Box float={"right"}>
          <Button variant={"primary"} onClick={pullbackOnClick}>
            {COMMON_LABELS.BTNS.PULL_BACK}
          </Button>
        </Box>
      )}
      {displayApprovalButton && (
        <Box float={"right"}>
          <SpaceBetween direction={"horizontal"} size={"l"}>
            <Button variant={"normal"} onClick={sendBackOnClick}>
              {COMMON_LABELS.BTNS.SEND_BACK}
            </Button>
            <Button variant={"primary"} onClick={approvalOnClick}>
              {COMMON_LABELS.BTNS.APPROVAL}
            </Button>
          </SpaceBetween>
        </Box>
      )}
    </ColumnLayout>
  );
};

export default Footer;
